import {
  BodyText,
  Radio,
  RadioGroup,
  Strong,
} from '@utilitywarehouse/hearth-react';
import { useEffect } from 'react';

import {
  IOTSProvider,
  IOTSSwitchOption,
  OTSServiceAction,
} from '@src/types/oneTouchSwitching';

export interface FoundHomePhoneProps {
  provider: IOTSProvider;
  homePhoneSuffix: string;
  switchOptions: IOTSSwitchOption[];
  switchingReference: string | null;
  setReference: (ref: string) => void;
  canUpdateState: boolean;
}

export const FoundHomePhone: React.FC<FoundHomePhoneProps> = ({
  provider,
  homePhoneSuffix,
  switchOptions,
  switchingReference,
  setReference,
  canUpdateState,
}) => {
  const selectedOption =
    switchOptions.find(
      (opt) => opt.switchingReference === switchingReference
    ) ?? null;
  const options = switchOptions.filter(
    (opt) =>
      opt.homePhoneAction === OTSServiceAction.Cease ||
      opt.homePhoneAction === OTSServiceAction.Retain
  );

  useEffect(() => {
    if (!switchingReference && canUpdateState) {
      setReference(switchOptions[0].switchingReference);
    }
  }, [switchingReference, switchOptions, setReference, canUpdateState]);

  return (
    <>
      {options.length > 1 && (
        <RadioGroup
          label={`Would you also like to cancel your home phone service (ending ${homePhoneSuffix}) with ${provider.name}?`}
          value={switchingReference ?? ''}
          onValueChange={setReference}
        >
          {options.map((opt) => (
            <Radio
              key={opt.switchingReference}
              value={opt.switchingReference}
              label={
                opt.homePhoneAction === OTSServiceAction.Cease
                  ? 'Yes, cancel my home phone service'
                  : 'No, keep my home phone service'
              }
            />
          ))}
        </RadioGroup>
      )}
      {selectedOption &&
        selectedOption.homePhoneAction === OTSServiceAction.ForcedCease && (
          <BodyText textAlign="center">
            <Strong>Please note:</Strong> Your home phone service with{' '}
            {provider.name} (ending <Strong>{homePhoneSuffix}</Strong>) will
            also be cancelled.
          </BodyText>
        )}
    </>
  );
};
